import { render, staticRenderFns } from "./autor_select.vue?vue&type=template&id=c681a1ee"
import script from "./autor_select.vue?vue&type=script&lang=js"
export * from "./autor_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports